module.exports = __webpack_public_path__ + "img/coach-slide1.bcdf29f8.png";